import ContactMessagesSmallComponentController from './controller';
import template from './component.tpl.html';

angular
    .module('festzelt-os.components')
    .component('contactMessagesSmall', {
        bindings: {
            contact: '<',
            store: '=',
            reloadAction: '&'
        },
        controller: ContactMessagesSmallComponentController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/components/components/contact-messages-small/component.js